/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Tab_OverviewInputs */

const en_analytics_tab_overview = /** @type {(inputs: Analytics_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const de_analytics_tab_overview = /** @type {(inputs: Analytics_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersicht`)
};

const fr_analytics_tab_overview = /** @type {(inputs: Analytics_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vue d'ensemble`)
};

const es_analytics_tab_overview = /** @type {(inputs: Analytics_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista general`)
};

const it_analytics_tab_overview = /** @type {(inputs: Analytics_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panoramica`)
};

const nl_analytics_tab_overview = /** @type {(inputs: Analytics_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overzicht`)
};

const pl_analytics_tab_overview = /** @type {(inputs: Analytics_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przegląd`)
};

const fi_analytics_tab_overview = /** @type {(inputs: Analytics_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yleiskatsaus`)
};

const da_analytics_tab_overview = /** @type {(inputs: Analytics_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oversigt`)
};

const sv_analytics_tab_overview = /** @type {(inputs: Analytics_Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Översikt`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Analytics_Tab_OverviewInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_tab_overview = /** @type {((inputs?: Analytics_Tab_OverviewInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Tab_OverviewInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_tab_overview(inputs)
	if (locale === "fr") return fr_analytics_tab_overview(inputs)
	if (locale === "es") return es_analytics_tab_overview(inputs)
	if (locale === "it") return it_analytics_tab_overview(inputs)
	if (locale === "nl") return nl_analytics_tab_overview(inputs)
	if (locale === "pl") return pl_analytics_tab_overview(inputs)
	if (locale === "fi") return fi_analytics_tab_overview(inputs)
	if (locale === "da") return da_analytics_tab_overview(inputs)
	if (locale === "sv") return sv_analytics_tab_overview(inputs)
	return en_analytics_tab_overview(inputs)
});